import { render, staticRenderFns } from "./payment-approval.vue?vue&type=template&id=6d72c0a6&scoped=true&"
import script from "./payment-approval.vue?vue&type=script&lang=js&"
export * from "./payment-approval.vue?vue&type=script&lang=js&"
import style0 from "./payment-approval.vue?vue&type=style&index=0&id=6d72c0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d72c0a6",
  null
  
)

export default component.exports